import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/contexts/AuthContext';
import useIsMounted from 'src/hooks/useIsMounted';
import { ILocalRoutes } from '../Sidebar/Sidebar.Interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack } from '@mui/material';
import styles from './Support.module.scss';

export const Support = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isMounted = useIsMounted()
  const { userRoutes } = useContext(AuthContext) // Retrieves the available routes from the authentication context
  const path = location.pathname.split('/').filter((item) => item)

  const [currentRoutes, setCurrentRoutes] = useState(() => {
    const initialRoute = userRoutes?.find(
      (route) =>
        route?.title?.toLocaleLowerCase() === path[0]?.toLocaleLowerCase(),
    )
    return initialRoute ? initialRoute.subModules : []
  })

  const handleCardClick = (route: ILocalRoutes) => {
    if (route.subModules && route.subModules.length > 0) {
      setCurrentRoutes(route.subModules)
    } else {
      navigate(route.route)
    }
  }

  useEffect(() => {
    if (!isMounted) return

    const initialRoute = userRoutes?.find(
      (route) =>
        route?.title?.toLocaleLowerCase() === path[0]?.toLocaleLowerCase(),
    )
    setCurrentRoutes(initialRoute ? initialRoute.subModules : [])
  }, [isMounted, location, userRoutes])

  return (
    <>
      <div className={styles.containerCard}>
        {/* Renders the cards for the submodules */}
        {currentRoutes?.map((route) => (
          <div
            id={route.keyName}
            onClick={() => handleCardClick(route)}
            key={route.keyName}
            className={`${styles.card} ${route.disabled ? styles.disabled : ''}`}
          >
            <Stack direction="row" spacing={2} alignItems={'center'}>
              {route.icon && (
                <FontAwesomeIcon icon={route.icon} className={styles.icon} />
              )}
              <h3 className={styles.title}>{route.title}</h3>
            </Stack>
            <p className={styles.description}>{route.description}</p>
          </div>
        ))}
      </div>
    </>
  )
}
